import * as React from 'react';
import { Container } from 'types/Watchlist';
import {
  formatFinalDestination,
  formatPickupLocationPort,
  formatPickupLocationTerminal,
} from 'utils/container-transforms';
import { Row, RowGroup } from '../components';

interface Props {
  container: Container;
}

export const Destination: React.FC<Props> = (props) => {
  const { container } = props;

  const destinationPort = formatPickupLocationPort(container);
  const pickupTerminal = formatPickupLocationTerminal(container);
  const finalDestination = formatFinalDestination(container);

  return (
    <RowGroup label="Destination">
      <Row label="Port of destination">{destinationPort?.value}</Row>
      <Row label="Pickup location">{pickupTerminal?.value || destinationPort?.value}</Row>
      <Row label="Final destination">{finalDestination?.value}</Row>
    </RowGroup>
  );
};
Destination.displayName = 'Shipments.DetailDrawer.Summary.Destination';
